import useFeatures from 'components/Map/hooks/useFeatures';
import { context } from 'components/Map/hooks/useMapContext';
import useMapState from 'components/Map/hooks/useMapState';
import useMarkers from 'components/Map/hooks/useMarkers';

import { TEST_ID } from './constants';
import type { Props } from './types';

const MapProvider = ({ children, mapOptions, testId = TEST_ID }: Props) => {
    const features = useFeatures({});
    const mapState = useMapState();
    const markers = useMarkers();

    return (
        <context.Provider
            value={{
                features,
                mapState,
                markers,
                options: mapOptions
            }}
            data-testid={testId}>
            {children}
        </context.Provider>
    );
};

MapProvider.displayName = 'MapProvider';

export default MapProvider;
